<template lang="pug">
PrInput.pr-input.bordered(
  v-nv,
  v-bind="$props",
  @nv-enter="enter",
  @nv-left="remove",
  @nv-back.stop="remove",
  @nv-numpad="typed",
  @nv-keyboard="typed",
  @nv-focus="focus",
  @nv-move="move"
)
  icon.icon.prefix.mr-4(:icon="icon", v-show="icon")
  .input-inner.d-flex.position-relative
    .label.font-weight-bold.small(v-show="label", :class="{ fluid, 'text-muted': value }") {{ label }}
    .input(ref="inputelement") {{ value }}
  icon.icon.small.keyboard(:icon="'fas keyboard'", v-show="showKeyboard") 
</template>

<script>
import styled from "vue-styled-components"

const Props = {
  text: Boolean,
  label: String,
  value: String,
  xsmall: Boolean,
  small: Boolean,
  outline: Boolean,
  floated: Boolean,
  fluid: Boolean,
  icon: String
}
const PrInput = styled("div", Props)`
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding: 0 15px;

  .keyboard {
    display: none;
  }

  &.nv-el-current {
    .keyboard {
      display: inherit;
    }
  }

  .icon {
    flex-grow: 0;

    &.prefix {
      ${props => (props.small ? "font-size: " + props.theme.font.small + ";" : "font-size: 1.5em;")}
    }
  }

  &.hasError {
    .prefix {
      display: block !important;
      &:before {
        content: "\f06a";
        color: #dc3545;
        font-weight: 900;
      }
      font-size: 80% !important;
    }
  }

  .input-inner {
    padding: 0 15px 0 0;
    overflow: hidden;
    flex-grow: 1;
    ${props => (props.floated && props.value ? "flex-direction:column;" : "")}

    .label {
      padding-right: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      ${props => (props.floated && props.value ? "padding-bottom:5px;" : props.floated ? "" : "max-width: 40%; min-width: 40%;")}
      ${props => (props.fluid ? "max-width:unset !important; min-width: unset !important; flex-grow: 0;" : "")}
    }

    .input {
      white-space: nowrap;
      overflow: hidden;
      flex-grow: 1;
    }
  }

  background: ${props => (props.theme.options.outline || props.outline ? "transparent" : props.theme.color.surface)};
  color: ${props => props.theme.color.onSurface};
  ${props => "border: 1px solid " + (props.outline ? props.theme.color.onSurface : props.theme.color.border) + ";"}
  ${props =>
    props.xsmall
      ? "padding: 0.35em 1em; font-size: " + props.theme.font.xsmall + ";"
      : props.small
      ? "padding: 0.5em 1.25em; font-size: " + props.theme.font.small + ";"
      : "padding: 0.75em 1.5em; font-weight:300; font-size: " + props.theme.font.base + ";"}
`

export default {
  name: "pr-input",
  components: {
    PrInput
  },
  props: {
    ...Props
  },
  computed: {
    showKeyboard() {
      return !__.device.numpad
    }
  },
  watch: {
    value() {
      this.$nextTick(() => {
        _$.nav._currentScope.currentElement.classList.add("nv")
        _$.nav._currentScope.currentElement.classList.add("nv-el-current")
      })
    }
  },
  methods: {
    remove() {
      if (!this.value) return
      this.$emit("update:value", this.value.slice(0, -1))
      this.$nextTick().then(() => (this.$refs.inputelement.scrollLeft = this.$refs.inputelement.scrollWidth))
    },
    typed($event) {
      this.$emit("update:value", (this.value || "") + $event.detail.value.toString())
      this.$nextTick().then(() => (this.$refs.inputelement.scrollLeft = this.$refs.inputelement.scrollWidth))
    },
    focus() {
      this.$refs.inputelement.scrollLeft = this.$refs.inputelement.scrollWidth
    },
    move() {
      this.$refs.inputelement.scrollLeft = 0
    },
    enter($event) {
      this.$keyboard($event.target, this.text ? "text" : "number")
    }
  }
}
</script>
